export default "__VITE_ASSET__YX9Tll4T__"